import React from 'react'
import { Container, Row, Col, NavLink } from 'react-bootstrap'
import { FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { SlSocialInstagram } from "react-icons/sl";
import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-scroll';
import { setToggleTrue } from '../../redux/slice/changeState';

const Footer = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  const dispatch = useDispatch()
  return (
    <div className='footer mt-7'>
      <Container>
        {isMobile ?
          <>
            <div className='mb-5'>
              <div className='footer-logo justify-content-between'>
                <div className='d-flex pt-2 w-100'>
                  <img src="/footeraspiration.png" style={{
    width: "121.65px",
    height: "19.5 px",
    objectFit: "contain",
  }} alt="aspiration"></img>
                  
                </div>
                <div className='social-icon d-flex text-end'>
                  <button><a href="https://www.instagram.com/irarealtyindia/profilecard/?igsh=ZTVlNGQ2YXhmeXp4" rel="noreferrer" target="_blank" className='text-dark'><SlSocialInstagram size={12} /></a></button>
                  <button><a href="https://www.linkedin.com/company/irarealtyindia/?originalSubdomain=in" rel="noreferrer" target="_blank" className='text-dark'><FaLinkedinIn size={12} /></a></button>
                  <button><a href="https://www.facebook.com/IRARealtyIndia/" rel="noreferrer" target="_blank" className='text-dark'><FaFacebookF size={12} /></a></button>
                </div>
              </div>
              <div className='pt-2'>
                <ul>
                  <li style={{ display: "inline-block", marginRight: "20px" }}>
                    <a href="/" style={{ textDecoration: "none", color: "#212529" }}>
                      Home
                    </a>
                  </li>
                  <li> <Link to="facing" smooth={true} duration={1000}>Floor Plans</Link></li>
                  <li><Link to="pricing-section" smooth={true} duration={1000}>Pricing</Link></li>
                  <li><Link to="location" smooth={true} duration={1000}>Location</Link></li>
                  <li><a onClick={() => dispatch(setToggleTrue())}>Contact</a></li>
                </ul>
              </div>
            </div>
            <Row>
            </Row>
          </>
          :
          <Row className='mb-5'>
            <Col lg={8}>
              <div className='footer-logo '>
                  <img src="/footeraspiration.png" alt="aspiration"></img>
                {/* <h6 className='ms-3'>©2026  IRA REALTY</h6> */}
              </div>
              <div>
                <ul>
                  <li style={{ display: "inline-block", marginRight: "20px" }}>
                    <a href="/" style={{ textDecoration: "none", color: "#212529" }}>
                      Home
                    </a>
                  </li>
                  <li> <Link to="facing" smooth={true} duration={1000}>Floor Plans</Link></li>
                  <li><Link to="pricing-section" smooth={true} duration={1000}>Pricing</Link></li>
                  <li><Link to="location" smooth={true} duration={1000}>Location</Link></li>
                  <li><a onClick={() => dispatch(setToggleTrue())}>Contact</a></li>
                </ul>
              </div>
            </Col>
            <Col lg={4} className='d-flex  justify-content-end align-items-end mb-3'>
              <div className='text-end social-icon d-flex justify-content-end align-items-start '>
                <button><a href="https://www.instagram.com/irarealtyindia/profilecard/?igsh=ZTVlNGQ2YXhmeXp4" rel="noreferrer" target="_blank" className='text-dark'><SlSocialInstagram size={20} /></a></button>
                <button><a href="https://www.linkedin.com/company/irarealtyindia/?originalSubdomain=in" rel="noreferrer" target="_blank" className='text-dark'><FaLinkedinIn size={20} /></a></button>
                <button><a href="https://www.facebook.com/IRARealtyIndia/" rel="noreferrer" target="_blank" className='text-dark'><FaFacebookF size={20} /></a></button>
              </div>
            </Col>
          </Row>
        }
      </Container>
      <div className='text-center copyright'>
        <Container>
          {isMobile ?
            <>
              <p className='text-capitalize'>© All trademarks, logos and names are properties of their respective owners.</p>
              <p className='text-capitalize'>All Rights Reserved. © Copyright 2026 IRA Reality Tech Private Limited. <NavLink>Terms of use</NavLink></p>
            </>
            :
            <span className='text-capitalize'>© All trademarks, logos and names are properties of their respective owners. All Rights Reserved. © Copyright 2026 IRA Reality Tech Private Limited. <a href="https://irarealty.in/terms-and-conditions" target='_blank' className='text-decoration-underline'>Terms of use</a></span>
          }
        </Container>
      </div>
    </div>
  )
}

export default Footer
